module.exports = __webpack_public_path__ + "img/shop-2.02b10133.png";